import { styled } from "styled-components";
import Button from "./Button";
import { Colors } from "../constants";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 64px;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 64px;
  max-width: 1024px;
  @media (max-width: 800px) {
    height: auto;
    flex-direction: column;
    gap: 32px;
    width: 100%;
  }
`;

const Nav = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 32px;
`;

const LogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  @media (max-width: 800px) {
    flex: none;
    width: 100%;
  }
`;

const Logo = styled.h1`
  font-family: "UnifrakturMaguntia", cursive;
  color: ${Colors.Tan};
  font-weight: normal;
  font-size: 164px;
  line-height: 90%;
  @media (max-width: 1200px) {
    font-size: 148px;
    line-height: 90%;
  }
  @media (max-width: 1000px) {
    font-size: 90px;
    line-height: 90%;
  }
`;

const Paragraph = styled.p`
  font-size: 14px;
  line-height: 140%;
  color: ${Colors.Tan};
  font-family: "Space Grotesk", sans-serif;
`;

const Rules = ({ setCurrentPage }) => {
  return (
    <Wrapper>
      <Content>
        <LogoWrapper>
          <Logo>Infinite Blood War</Logo>
        </LogoWrapper>
        <Nav>
          <Paragraph>
            Infinite Blood War is a rules light old school roleplaying game.
            Everything, including you, dies in one hit. If you die, instantly
            generate a new, weird character. Play for as many or as few
            encounters as you want.
          </Paragraph>
          <Button onClick={() => setCurrentPage("character")} type="secondary">
            Get Character
          </Button>
          <Button onClick={() => setCurrentPage("encounter")} type="secondary">
            Get Encounter
          </Button>
        </Nav>
      </Content>
    </Wrapper>
  );
};

export default Rules;
